import { render } from "./ClubDealOpenJoin.vue?vue&type=template&id=c397e660&scoped=true&ts=true"
import script from "./ClubDealOpenJoin.vue?vue&type=script&lang=ts"
export * from "./ClubDealOpenJoin.vue?vue&type=script&lang=ts"

import "./ClubDealOpenJoin.vue?vue&type=style&index=0&id=c397e660&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c397e660"]])

export default __exports__